// Kennungen sind UUID (Version 4): weltweit eindeutig, entstehen schon am
// Gerät – auch ohne Empfang – und passen später zu jedem angeschlossenen
// Programm (PLAN.md, Abschnitt 4; DECISIONS.md 13.10., Punkt 15).

const UUID_MUSTER = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;

/** Eine neue Kennung – am Gerät wie am Server dieselbe Funktion. */
export function neueKennung(): string {
  return globalThis.crypto.randomUUID();
}

export function istKennung(wert: unknown): wert is string {
  return typeof wert === "string" && UUID_MUSTER.test(wert);
}
